import { Brand } from './Brand';
import { Type } from './Type';
import { Environment } from './Environment';
export function getClientID(brand, type, environment) {
    if (type === Type.Team) {
        switch (environment) {
            // FIXME: reduce to one team tenant per environment instead of two
            // using `lendi-team-*` for now
            case Environment.Development:
                return 'IdtM2Iu7uhHWQNRMVB6vuaeSo0tRmkXe';
            case Environment.Staging:
                return '7VfZtkRmcNwkL5hLrr2JOz6ID09aQx5S';
            case Environment.Preproduction:
                return 'Q1kDu5GAx4xslZa9yCNg09Iu8KjbTqTb';
            case Environment.Production:
                return 'oVRWqJ9V6BjAKExYQEYHbmbHD9ey4BA7';
        }
    }
    if (brand === Brand.Lendi && type === Type.Customer) {
        switch (environment) {
            case Environment.Development:
                return '02HMKpY3DBWow93s4Liv4hOo7LBy5E0v';
            case Environment.Staging:
                return 'KX2f6VfN8m46kAmo2aeVJ6rp3ZSn8G6V';
            case Environment.Preproduction:
                return 'Wo0q6I3JX2gpgCW2ACNvi1z2Ua3YeLoW';
            case Environment.Production:
                return 'HRuDIzIv8Y0X5XNcCzN6xu0E84VkGS0z';
        }
    }
    if (brand === Brand.Aussie && type === Type.Customer) {
        switch (environment) {
            case Environment.Development:
                return 'BmMQl2jaxrMHr8S814STOl46RH75Bb5V';
            case Environment.Staging:
                return '8hO4kNgj4ejLlnh5PRooHQt6g0x88Cqe';
            case Environment.Preproduction:
                return 'YA3q6iku85NDdWOfUQXCOeuB0kD3q5qb';
            case Environment.Production:
                return '3Kb8uy7nsTawMVTviFmuBjSCkajs24GE';
        }
    }
    throw new Error("Unable to determine client ID for ".concat(brand, " ").concat(type, " ").concat(environment, "."));
}
//# sourceMappingURL=getClientID.js.map